var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgEmptyNotification = function SvgImgEmptyNotification(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "m14.653 39.37 23-16.669a4 4 0 0 1 4.694 0l23 16.67A4 4 0 0 1 67 42.61V69H13V42.61a4 4 0 0 1 1.653-3.24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "m9.5 41.5 21 15L11 73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m49 41.5 22 15L51 73"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m11.028 36.326 26.594-19.663a4 4 0 0 1 4.756 0l26.594 19.663A5 5 0 0 1 71 40.346V69a5 5 0 0 1-5 5H14a5 5 0 0 1-5-5V40.346a5 5 0 0 1 2.028-4.02z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BDBDBD",
    fillOpacity: 0.3,
    d: "M36.5 63h7a2.5 2.5 0 1 1 0 5h-7a2.5 2.5 0 1 1 0-5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m11 73 27.722-23.03a2 2 0 0 1 2.556 0L69 73"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(-1 0 0 1 120 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#BDBDBD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "m30.5 13.5-4-5m24 5 4-5m-14 2v-6"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgEmptyNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-empty-notification.4d9b926fb050ec093e29172c108aed10.svg";